import React from 'react';
import { Form, InputGroup } from 'react-bootstrap';

const GlobalJobSearch = ({ searchTerm, setSearchTerm, placeholder = "Search jobs by number, name, or model" }) => {
  return (
    <div className="global-search-container mb-3">
      <div className="search-container" style={{ maxWidth: '500px' }}>
        <InputGroup>
          <InputGroup.Text>
            <i className="bi bi-search"></i>
          </InputGroup.Text>
          <Form.Control
            placeholder={placeholder}
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          {searchTerm && (
            <InputGroup.Text 
              className="clear-search" 
              onClick={() => setSearchTerm("")}
              style={{ cursor: 'pointer' }}
            >
              <i className="bi bi-x-circle"></i>
            </InputGroup.Text>
          )}
        </InputGroup>
      </div>
    </div>
  );
};

export default GlobalJobSearch;
